module.exports = __webpack_public_path__ + "static/media/view-details-right-chevron.d26a8389.svg";